import { products, StoreLink } from '../config/company';
import { GooglePlayIcon, AppleIcon } from './StoreIcons';
import './Products.css';

function StoreBadge({ link }: { link: StoreLink }) {
  return (
    <a
      className="product__store-badge"
      href={link.url}
      target="_blank"
      rel="noopener noreferrer"
    >
      {link.store === 'google-play' ? <GooglePlayIcon /> : <AppleIcon />}
      <span>{link.label}</span>
    </a>
  );
}

function Products() {
  return (
    <section className="section products" id="products">
      <div className="container">
        <h2 className="section__title">Products &amp; Services</h2>
        <p className="section__subtitle">What we build</p>

        {products.map((product) => (
          <article className="product" key={product.name}>
            <div className="product__header">
              <div className="product__logo" aria-hidden="true">
                T
              </div>
              <div>
                <h3 className="product__name">{product.name}</h3>
                <p className="product__tagline">{product.tagline}</p>
              </div>
            </div>

            <p className="product__description">{product.description}</p>

            <ul className="product__features">
              {product.features.map((feature) => (
                <li className="product__feature" key={feature.title}>
                  <h4 className="product__feature-title">{feature.title}</h4>
                  <p className="product__feature-text">{feature.text}</p>
                </li>
              ))}
            </ul>

            <div className="product__downloads">
              {product.storeLinks.map((link) => (
                <StoreBadge key={link.store} link={link} />
              ))}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Products;
